import { useEffect, useState } from 'react';
import { getMyAgencyProfile } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Building2, LifeBuoy, Mail, Phone, UserRound } from 'lucide-react';
import { InfoRow, displayAgencyName } from './AgencyPortalShared';

export default function AgencySupport() {
  const [agency, setAgency] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getMyAgencyProfile();
        if (!cancelled) setAgency(res.data || null);
      } catch (err) {
        console.error(err);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="space-y-6 animate-fade-in">
      <div>
        <h2 className="text-2xl font-semibold text-[#062B1A]" style={{ fontFamily: 'var(--font-display)' }}>
          Support
        </h2>
        <p className="mt-1 text-sm text-[#062B1A]/60">MCC partner support contacts.</p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Card className="border border-[rgba(6,43,26,0.08)] shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-base font-semibold text-[#062B1A]" style={{ fontFamily: 'var(--font-display)' }}>
              <LifeBuoy className="h-4 w-4 text-[#D4AF37]" />
              Agency Support
            </CardTitle>
          </CardHeader>
          <CardContent>
            <InfoRow label="Email" value="admissions@metropolitancollege.ca" />
            <InfoRow label="Phone" value="+1 (604) 300-3123" />
            <InfoRow label="Agency" value={displayAgencyName(agency)} />
            <InfoRow label="MCC Representative" value={agency?.owner} />
          </CardContent>
        </Card>

        <Card className="border border-[rgba(6,43,26,0.08)] shadow-sm">
          <CardHeader className="pb-3">
            <CardTitle className="flex items-center gap-2 text-base font-semibold text-[#062B1A]" style={{ fontFamily: 'var(--font-display)' }}>
              <Building2 className="h-4 w-4 text-[#D4AF37]" />
              Account
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="rounded-lg border border-[rgba(6,43,26,0.08)] bg-[#F7F8FA] p-4">
              <div className="mb-3 flex items-center gap-2">
                <UserRound className="h-4 w-4 text-[#D4AF37]" />
                <span className="text-sm font-semibold text-[#062B1A]">Primary agency contact</span>
              </div>
              <p className="text-sm font-medium text-[#062B1A]">{agency?.mainContact?.name || agency?.agent_name || 'Not set'}</p>
              <div className="mt-2 flex flex-wrap gap-2">
                {agency?.mainContact?.email && (
                  <Badge variant="outline" className="border-[#062B1A]/12 bg-white/70 text-[#062B1A]/70">
                    <Mail className="mr-1 h-3 w-3" />
                    {agency.mainContact.email}
                  </Badge>
                )}
                {agency?.mainContact?.phone && (
                  <Badge variant="outline" className="border-[#062B1A]/12 bg-white/70 text-[#062B1A]/70">
                    <Phone className="mr-1 h-3 w-3" />
                    {agency.mainContact.phone}
                  </Badge>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
